import { Button } from "./ui/button"

export default function AccessDenied() {
  const handleLogout = () => {
    // Signal the OIDC web component to log out
    const authComponent = document.querySelector('umd-auth')
    if (authComponent) {
      authComponent.dispatchEvent(new CustomEvent('umd-logout'))
    }
    
    // Reload page after short delay
    setTimeout(() => {
      window.location.href = '/'
    }, 500)
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
          
          <div className="mb-6">
            <p className="text-gray-700 mb-4">
              You do not have permission to access this application.
            </p>
            <p className="text-gray-700">
              If you believe this is an error, please contact your system administrator.
            </p>
          </div>
          
          <Button 
            onClick={handleLogout}
            className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded"
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  )
}